<app-title class="title" title="Inicio" />

<div class="container-fluid mt-3">
  @for (menu of menuService.menuData() ; track menu.id) {
  <div class="row-1 mt-3">
    <h4 class="title">{{ menu.nombre }}</h4>
    <!--Submenu-->
    <div class="row mt-4">
      @for (subMenu of menu.subMenu ; track subMenu.nombre) {
      <div class="col-lg-2 col-md-3 col-sm-6 col-12 mb-3">
        <a routerLink="{{ menu.nombre }}/{{ subMenu.accion }}">
          <div class="card card-inicio">
            <div
              class="card-body d-flex flex-column justify-content-center align-items-center"
            >
              <img
                class="img-fluid"
                width="80"
                height="80"
                src="/assets/images/sidebar/{{ subMenu.icono }}"
                alt=""
              />
              <p class="card-title mt-3">{{ subMenu.nombre }}</p>
            </div>
          </div>
        </a>
      </div>
      }
    </div>
  </div>
  }
</div>
